import {
    START_LOADING_SESSION,
    END_LOADING_SESSION,
    START_LOGGING_IN,
    END_LOGGING_IN
} from '../constants';
import {
    StartLoadSession,
    EndLoadSession,
    StartLoginAction,
    EndLoginAction
} from '~/frontend/src/actions/login';

export type LoginState = {
    loadingSession : boolean;
    loggingIn : boolean;
}

/**
 *
 * @param login
 * @param action
 */
export default function loginReducer(
    login : LoginState = { loadingSession: false, loggingIn: false },
    action : StartLoadSession | EndLoadSession | StartLoginAction | EndLoginAction
) : LoginState {

    if ( [ START_LOADING_SESSION, END_LOADING_SESSION, START_LOGGING_IN, END_LOGGING_IN ].includes( action.type ) ) {
        login = {
            ...login
        };

        switch ( action.type ) {
            case START_LOADING_SESSION:
                login.loadingSession = true;
                break;
            case END_LOADING_SESSION:
                login.loadingSession = false;
                break;
            case START_LOGGING_IN:
                login.loggingIn = true;
                break;
            case END_LOGGING_IN:
                login.loggingIn = false;
                break;
        }
    }

    return login;
}
